import RouterErrorBox from "components/RouterErrorBox";
import type { NonIndexRouteObject } from "react-router-dom";
import MonitoringRootRoute from "./MonitoringRootRoute";
import MonitoringRoute from "./MonitoringRoute";

export const monitoringRoute: NonIndexRouteObject = {
  element: <MonitoringRootRoute />,
  errorElement: <RouterErrorBox />,
  children: [
    {
      index: true,
      element: <MonitoringRoute />,
    },
  ],
};
